import React from 'react';
import { Card, Table, Tag, Button, Typography } from 'antd';

const { Text } = Typography;

const sourceColor = { deterministic: 'geekblue', human: 'gold', learned: 'blue' };

/**
 * Renders the append-only transform log so the user can see exactly what the system
 * changed and why. Props:
 *  - entries: [{ rowId, field, op, before, after, reason, source }]
 *  - onDownloadCsv(), onDownloadJson()
 */
function AuditLogPanel({ entries = [], onDownloadCsv, onDownloadJson }) {
  return (
    <Card
      size="small"
      title={`Transformation log (${entries.length})`}
      extra={
        <span>
          <Button size="small" onClick={onDownloadCsv} style={{ marginRight: 8 }}>CSV</Button>
          <Button size="small" onClick={onDownloadJson}>JSON</Button>
        </span>
      }
    >
      <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
        Every reformat, generated code, assumed value, and flag is recorded here — the audit trail behind each row.
      </Text>
      <Table
        dataSource={entries.map((e, i) => ({ key: i, ...e }))}
        rowKey="key"
        size="small"
        pagination={{ pageSize: 12, size: 'small' }}
        columns={[
          { title: 'Row', dataIndex: 'rowId', key: 'rowId', width: 90 },
          { title: 'Field', dataIndex: 'field', key: 'field', width: 150 },
          { title: 'Op', dataIndex: 'op', key: 'op', width: 90,
            render: (t) => <Tag>{t}</Tag> },
          { title: 'Before', dataIndex: 'before', key: 'before', width: 140,
            render: (t) => <Text type="secondary">{String(t)}</Text> },
          { title: 'After', dataIndex: 'after', key: 'after', width: 140 },
          { title: 'Reason', dataIndex: 'reason', key: 'reason' },
          { title: 'Source', dataIndex: 'source', key: 'source', width: 110,
            render: (t) => <Tag color={sourceColor[t] || 'default'}>{t}</Tag> },
        ]}
      />
    </Card>
  );
}

export default AuditLogPanel;
